import { FILE_MESSAGE_TEXT_CONTENT } from './transaction';

export const resolveFileMessageType = message => {
    const { attributes } = message || {};
    const { file, content } = attributes || {};

    const fileTextContent = content === FILE_MESSAGE_TEXT_CONTENT;
    const messageIsFile = file && fileTextContent;
    const fileIsImage = messageIsFile && /image/.test(file.mimeType);
    const fileIsDoc = messageIsFile && !fileIsImage;

    return { fileIsDoc, fileIsImage };
};
